import type { ScheduleCoverageRow } from "./schedule";

export type SlotTone = "filled" | "partial" | "open" | "at-risk" | "draft" | "cancelled" | "unknown";

/** Slot lifecycle outranks coverage: draft/cancelled mute the row regardless of fill. */
export function slotTone(row: ScheduleCoverageRow): SlotTone {
  if (row.slotStatus === "draft" || row.slotStatus === "cancelled") {
    return row.slotStatus;
  }
  if (row.declinedCount > 0) {
    return "at-risk";
  }
  if (row.coverageStatus === "filled" || row.coverageStatus === "partial" || row.coverageStatus === "open") {
    return row.coverageStatus;
  }
  return "unknown";
}

export const SLOT_TONE_COPY: Record<SlotTone, string> = {
  filled: "Filled",
  partial: "Partial",
  open: "Open",
  "at-risk": "At risk",
  draft: "Draft",
  cancelled: "Cancelled",
  unknown: "Unknown",
};
